module.exports = __webpack_public_path__ + "img/bg-main-pc.53b7405e.jpg";